import React, { useEffect, useState } from "react";
import { Form, Input, Button, Card, Row, Col } from "antd";
import "antd/dist/reset.css";
import Permissions from "../Permissions";
import TableComponent from "../../components/TableComponent";
import { createRoles, getRolesApi } from "../../services/roles";
import { allPermissions } from "../../utils/permissions";
import { toast } from "react-toastify";

export default function Role() {
  const [form] = Form.useForm();
  const [checkedList, setCheckedList] = useState([]);
  const [listData, setListData] = useState([]);
  const [create, setCreate] = useState(false);

  const getRolesFetch = async () => {
    try {
      const roles = await getRolesApi();
      setListData(roles || []);
    } catch (error) {
      console.error("Failed to fetch roles:", error);
    }
  };

  useEffect(() => {
    getRolesFetch();
  }, []);

  const handleSubmit = async (values) => {
    let list = []
    checkedList.forEach(x=>{
      let find = allPermissions.find(y=>y.slug===x)
      if(find) list.push(find)
        return  
    })
    console.log("Form submitted:", values, list);
    let res = await createRoles({...values,permissions:list})
      if(res?.sucess)  toast.success(res?.message||'Role created sucessfully!')
        else  toast.error('something went wrong to create role!')
      setCheckedList([])
    // Add your submit logic here (e.g. API call)
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text) => <span>{text || "No description"}</span>,
    },
  ];

  return (
    <>
      <div style={{ margin: "10px 0 20px 10px" }}>
        <Button
          title="role"
          size="large"
          type="primary"
          danger={create}
          onClick={() => setCreate(!create)}
        >
          {create ? "Cancel" : "Create Role"}
        </Button>
      </div>

      {create && (
        <CreateRole
          form={form}
          handleSubmit={handleSubmit}
          checkedList={checkedList}
          setCheckedList={setCheckedList}
        />
      )}

      <TableComponent columns={columns} data={listData} />
    </>
  );
}

const CreateRole = ({ handleSubmit, form, checkedList, setCheckedList }) => {
  return (
    <Row justify="center" style={{ padding: "2rem" }}>
      <Col xs={24} sm={20} md={16} lg={12} xl={10}>
        <Card
          title="Create Role"
          bordered={false}
          style={{
            borderRadius: 12,
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            initialValues={{ name: "", description: "" }}
          >
            <Form.Item
              label="Name"
              name="name"
              rules={[
                { required: true, message: "Please input the role name!" },
              ]}
            >
              <Input placeholder="Enter role name" />
            </Form.Item>

            <Form.Item
              label="Description"
              name="description"
              rules={[
                {
                  required: true,
                  message: "Please input the role description!",
                },
              ]}
            >
              <Input.TextArea rows={4} placeholder="Enter role description" />
            </Form.Item>

            <div style={{ marginBottom: 10 }}>
              <Permissions
                checkedList={checkedList}
                setCheckedList={setCheckedList}
              />
            </div>

            <Form.Item>
              <Button type="primary" htmlType="submit" block>
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};
